import axios from 'axios'

interface InformaticaSuggestedAddressProps {
  authToken: string
  userInput: string
  country: string
  jobToken?: string
  resultCount?: number
}

export interface InformaticaSuggestedAddressResponse {
  JobToken: string
  Response: { ResultInfo: InformaticaResultInfo; Results: InformaticaResults[] }[]
  Status: 'Ok' | 'Rejected'
  StatusDescription: string
}

interface InformaticaResultInfo {
  SourceID: string
  ProcessStatus: string
  ProcessModeUsed: string
  ResultCount: number
  ResultCountOverflow: boolean
  ResultCountries: [string]
}

export interface InformaticaResults {
  Variants: {
    AddressElements: InformaticaAddressElements
    PreformattedData: InformaticaPreformattedData
    StatusValues: InformaticaResultStatusValues
  }[]
}

interface InformaticaResultStatusValues {
  AddressCount: string
  AddressType: string
  LanguageISO3: string
  MatchPercentage: string
  ResultGroup: string
  ResultQuality: number
}

interface InformaticaPreformattedData {
  SingleAddressLine: {
    Value: string
  }
}

interface InformaticaAddressElements {
  AdministrativeDivision?: Record<'Value', string>[]
  Building?: Record<'Value', string>[]
  HouseNumber?: Record<'Value', string>[]
  SubBuilding?: Record<'Value', string>[]
  Country?: { Code: string; Name: string }[]
  Locality?: Record<'Value', string>[]
  PostalCode?: Record<'Value', string>[]
  Street?: Record<'Value', string>[]
}

export const getInformaticaSuggestedAddresses = async ({
  authToken,
  userInput,
  country,
  jobToken,
  resultCount = 5,
}: InformaticaSuggestedAddressProps): Promise<InformaticaSuggestedAddressResponse> => {
  const informaticaAddressURL = 'https://eu-av.informaticadaas.com/AV6/v1/process'
  const transactionTypes = {
    prod: 'PRODUCTION',
    test: 'TEST',
  }
  const config = {
    AuthenticationToken: authToken,
    UseTransactions: transactionTypes.prod,
    ...(jobToken && { Jobtoken: jobToken }),
    Request: {
      Parameters: {
        Mode: 'QuickCapture',
        CountrySets: [
          {
            Result: {
              MaxResultCount: resultCount,
            },

            OutputDetail: {
              PreformattedData: {
                SingleAddressLine: true,
                PostalLocalityLine: false,
                PostalFormattedAddressLines: false,
                NumberAndSubBuilding: false,
                PostalDeliveryAddressLines: false,
                PostalRecipientLines: false,
                StreetWithNumber: false,
                SingleAddressLineDelimiter: 'Space',
              },

              OutputStatusForEmptyElements: false,
              SubItems: false,
              ElementStatus: false,
            },
          },
        ],
      },
      IO: {
        Inputs: [
          {
            PreformattedData: {
              SingleAddressLine: userInput,
            },
            AddressElements: {
              Country: country,
            },
          },
        ],
      },
    },
  }

  const response = await axios.post(informaticaAddressURL, config)
  return response.data
}
